<template>
  <div class="width100 margin-auto">
    <!-- 检索 -->
    <div class="Retrieveform">
      <div class="f16 width98 textalign-left dimensional">工业设计新增</div>
      <div class="pad-top30">
        <p class="textalign-left pad-bot10">项目名称</p>
        <el-input
          placeholder="请输入项目名称"
          v-model="title"
          class="width100"
        ></el-input>
      </div>
      <div class="pad-top20">
        <p class="textalign-left pad-bot10">项目类别</p>
        <el-select
          class="width100"
          v-model="cate_id"
          placeholder="请选择项目类别"
          :filterable="true"
        >
          <el-option label="---  请选择  ---" value=""></el-option>
          <el-option
            v-for="item in options"
            :key="item.i"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="pad-top20">
        <p class="textalign-left pad-bot10">项目备注</p>
        <el-input
          placeholder="请输入项目备注"
          type="textarea"
          :autosize="autosize"
          v-model="remark"
          class="width100"
        ></el-input>
      </div>
      <div class="textalign-right pad-top20">
        <el-button @click="dialognull()">取 消</el-button>
        <el-button
          class="margin-top20"
          type="primary"
          @click="toaddPersonnel()"
        >
          保 存
        </el-button>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  entdesignproductsave,
  entdesignproductcate,
} from "@/api/newhead/newhead.api";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      errormessage: "",
      dialogVisiblenull: false,
      form: {},
      title: "",
      cate_id: "",
      remark: "",
      id: "",
      options: [],
    };
  },
  methods: {
    toaddPersonnel() {
      entdesignproductsave({
        cate_id: this.cate_id,
        title: this.title,
        remark: this.remark,
        id: this.id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success",
          });
          BUS.$emit("indusdesign", 1);
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    dialognull() {
      BUS.$emit("indusdesign", 2);
    },
  },
  created() {
    entdesignproductcate({}).then((res) => {
      this.options = res.data.data;
    });
  },
};
</script>
<style scoped>
.Retrieveform {
  background: #fff;
}
.preservation {
  background: #409eff;
  color: white;
  width: 80px;
  text-align: center;
  border-radius: 5px;
  line-height: 30px;
  float: right;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>